import Vue from 'vue';
import Main from './Message.vue';
let MessageConstructor = Vue.extend(Main);

const Message = function (options) {
    let instance = new MessageConstructor({
        data: options
    }).$mount();
    document.getElementById('alert').appendChild(instance.$el);

}

export default Message;